export const FEATURES_CONSTANTS = {
  title: "Key Benefits of POC-as-a-Service (POCaaS)",
  list: [
    {
      label: "Real-Time Testing",
      text: "Enables businesses to validate solutions under real-world conditions, ensuring optimal performance.",
    },
    {
      label: "Digital Twin Simulation",
      text: "Creates a virtual model of the production environment, allowing for in-depth analysis.",
    },
    {
      label: "Cost-Effective Evaluation",
      text: "Eliminates the need for extensive in-house testing resources, saving time and money.",
    },
    {
      label: "Risk Reduction",
      text: "Identifies potential integration and functionality issues before full deployment.",
    },
    {
      label: "Scalability",
      text: "Supports multiple testing environments, allowing businesses to scale POC projects as needed.",
    },
    {
      label: "Seamless Cloud Integration",
      text: "Ensures compatibility with cloud-based applications, services, and platforms.",
    },
    {
      label: "Data-Driven Decision Making",
      text: "Provides valuable insights through performance analysis and reports.",
    },
    {
      label: "Rapid Prototyping",
      text: "Speeds up the innovation cycle by enabling faster iterations and refinements.",
    },
  ],
};
